import { useContext } from 'react'
import TopBarContext from '@/contexts/TopBarContext'

const useTopBarInfo = () => useContext(TopBarContext)

export default useTopBarInfo
